import { ChangeDetectionStrategy, Component, inject, Input, Type, ViewEncapsulation } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { FeedbackMode } from '@panaya/ui/p-like-dislike';
import { FeedbackDialogResult } from '@panaya/ui/p-feedback';
import { AiUserFeedbackParams } from './models/ai-user-feedback-params';
import { AiCallType } from './models/ai-call-type.enum';
import {
    IAiFeedbackService,
    IPDialogService,
    injectPAiDialogService,
    injectPAiFeedbackDialogComponent,
    injectPAiFeedbackService
} from './p-ai-feedback-config.provider';
import { P_AI_FEEDBACK_CONTEXT } from './p-ai-feedback-context.provider';

@Component({
    selector: 'p-ai-feedback',
    template: `
        <p-like-dislike
            style="flex-direction:row; align-items:center"
            (feedbackClicked)="aiUserFeedbackClicked($event)"
            (click)="$event.stopPropagation()"
            [attr.automation-id]="(context || this).automationPrefix + '_like-dislike'"
        ></p-like-dislike>
    `,
    styleUrls: ['./p-ai-feedback.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PAiFeedbackComponent {
    @Input() automationPrefix = '';
    @Input() projectId = 0;
    @Input() requestId = '';
    @Input() entityId = 0;
    @Input() aiCallType!: AiCallType;

    private readonly dialogService: IPDialogService = injectPAiDialogService();
    private readonly feedbackDialogComponent: Type<unknown> = injectPAiFeedbackDialogComponent();
    private readonly service: IAiFeedbackService = injectPAiFeedbackService();
    protected readonly context = inject(P_AI_FEEDBACK_CONTEXT, { optional: true });

    aiUserFeedbackClicked(feedbackMode: FeedbackMode): void {
        const ctx = this.context || this;

        const aiUserFeedbackParams: AiUserFeedbackParams = {
            projectId: ctx.projectId,
            aiAuditRequestId: ctx.requestId,
            feedbackPreference: feedbackMode,
            entityId: ctx.entityId,
            aiCallType: ctx.aiCallType
        };

        if (feedbackMode === FeedbackMode.DISLIKE) {
            this.openFeedbackDialog(aiUserFeedbackParams);
        } else {
            this.service.saveAiUserFeedback(aiUserFeedbackParams).subscribe();
        }
    }

    private openFeedbackDialog(aiUserFeedbackParams: AiUserFeedbackParams): void {
        this.dialogService
            .open<unknown, MatDialogConfig, FeedbackDialogResult | undefined>(this.feedbackDialogComponent, {
                panelClass: 'p-dialog-small'
            })
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    const { issue, review } = result;
                    aiUserFeedbackParams.feedbackReason = issue;
                    aiUserFeedbackParams.feedbackText = review;
                }
                this.service.saveAiUserFeedback(aiUserFeedbackParams).subscribe();
            });
    }
}
